import type {Connection} from './Connection.js'
import {gitHubRepositoryFixture} from '../github/index.js'

export const iCalSubscriptionConnectionFixture = {
  id: 'conn-1',
  type: 'ical-subscription',
  name: 'Foo',
  url: 'https://localhost/calendar.ics',
  projectId: 'pr-1',
} satisfies Connection

export const gitHubApiConnectionFixture = {
  id: 'conn-1',
  type: 'github-api',
  name: 'Foo',
  maskedApiKey: 'ghp_api-key****',
  repositories: [
    {...gitHubRepositoryFixture, id: 1, name: 'organization/foo'},
    {...gitHubRepositoryFixture, id: 2, name: 'organization/bar', projectId: undefined},
    {...gitHubRepositoryFixture, id: 3, name: 'organization/baz', disabledTime: '2025-03-14T00:00:00Z'},
  ],
} satisfies Connection

export const jiraApiConnectionFixture = {
  id: 'conn-1',
  type: 'jira-api',
  name: 'Foo',
  username: 'marvin@mstuercke.dev',
  maskedApiKey: 'api-key****',
  projectKey: 'FOO',
  projectId: 'pr-1',
  domain: 'https://mstuercke.atlassian.net',
} satisfies Connection
